// Module
var code = "<template>\n  <require from=\"./pen-specification-container\"></require>\n  <pen-specification-container\n    pen-id.bind=\"data.penId\"\n  ></pen-specification-container>\n</template>";
// Exports
export default code;